import React from "react";
import { Avatar, Box, Divider, Stack, Typography, useTheme } from "@mui/material";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, timelineItemClasses, TimelineSeparator } from "@mui/lab";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as MailIcon } from "assets/PwC_Funct_Icons_Email_Outline_Black_RGB.svg"


function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */

    for (i = 0; i < string?.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name?.split(' ')?.[0]?.[0]}`,
    };
}

const MyWorkLineOld = (props) => {
    const { path, myWorkListdata,type } = props
    const navigate = useNavigate();
    const { projectId } = useParams();
    const theme = useTheme();

    // const myWorkListRes = useGetMyWorkQuery({ projectId, type: type });

    // useEffect(() => {
    //     if (myWorkListRes?.isSuccess) {
    //         setMyWorkList(myWorkListRes?.data?.data)
    //     }
    // }, [myWorkListRes?.isSuccess])

    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    return (
        <>
            <Box sx={{ background: "#fff", borderRadius: "5px", marginTop: "15px", position: "relative" }}>
                {/* Header */}
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                    <Stack direction="row" spacing={1}>
                        {/* <Typography sx={{ background: theme?.customSettings?.themeColor, borderRadius: "2px", height: "32px", fontWeight: "500", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.4px", padding: "2px 6px 2px 6px", color: "#FFFFFF", display: "flex", alignItems: "center", gap: "6px" }}><MailOutlineIcon sx={{ fontSize: 18 }} />Pending For Approval</Typography> */}
                        <Typography sx={{ background: theme?.customSettings?.themeColor, borderRadius: "2px", height: "32px", fontWeight: "500", fontSize: "16px", lineHeight: "24px", letterSpacing: "0.4px", padding: "2px 6px 2px 6px", color: "#FFFFFF", display: "flex", alignItems: "center", gap: "6px" }}><MailIcon style={{ height: "26px", width: "26px", fill: "#FFFFFF", }} />Pending For Approval</Typography>
                    </Stack>
                </Stack>
                <Divider sx={{ marginLeft: "-15px" }} />
                {myWorkListdata?.length > 0 ?
                    <Timeline
                        sx={{
                            [`& .${timelineItemClasses.root}:before`]: {
                                flex: 0,
                                padding: 0,
                            }
                        }}
                    >
                        {myWorkListdata?.map((val, index) => {
                            return (
                                <TimelineItem key={index}>
                                    <TimelineSeparator>
                                        <TimelineConnector />
                                        <TimelineDot sx={{
                                            padding: '0px', boxShadow: 'none', margin: "6.5px 0px", borderStyle: 'none', backgroundColor: "inherit"
                                        }}>
                                            <Avatar {...stringAvatar(val?.name)} />
                                        </TimelineDot>
                                        <TimelineConnector />
                                    </TimelineSeparator>

                                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary">
                                            {moment(val?.pendingFrom)?.format('[Pending since] MMMM DD, YYYY')}
                                        </Typography>
                                        <Typography variant="h6" component="span"
                                            onClick={() => {
                                                let encrypted = encrypt("edit");
                                                if (val?.isEditable) {
                                                    encrypted = encrypt("view");
                                                }
                                                navigate(`/projects/${projectId}/${type}-detail/${val?.id}/${encrypted}/${val?.isEditable}`)
                                            }}
                                            sx={{ color: "#1C1C1C", cursor: 'pointer', fontWeight: 400, fontSize: '16px', lineHeight: index === 0 ? "32px" : "24px" }}>
                                            {val?.name}
                                        </Typography>
                                        <Typography sx={{ fontSize: '14px' }}>{val?.discription}</Typography>
                                    </TimelineContent>
                                </TimelineItem>
                            )
                        })

                        }
                    </Timeline>

                    : <Typography variant="caption" sx={{ textAlign: 'center' }}>

                        Record not found.
                    </Typography>
                }
            </Box>
        </>
    );
}

export default MyWorkLineOld;
